var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection7WhiteStrike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 22,
    viewBox: "0 0 451 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_2688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80307 5.07391C103.695 -6.65185 431.335 5.55354 445.249 6.07104C448.659 6.19726 451.248 7.71189 450.999 9.45371C450.75 11.1072 448.037 12.3694 444.801 12.3694C444.652 12.3694 444.478 12.3694 444.328 12.3694C442.138 12.281 301.33 7.04292 175.63 6.42445C274.945 9.7945 399.574 15.3608 407.39 15.7016C410.825 15.853 413.339 17.3803 413.04 19.1221C412.767 20.7629 410.028 21.9999 406.842 21.9999C406.668 21.9999 406.469 21.9999 406.295 21.9999C403.432 21.8737 119.277 9.21389 63.3965 10.2489C60.31 10.312 57.796 9.277 57.1239 7.86335C37.3604 8.63329 20.4346 9.71877 7.64062 11.246C4.28033 11.6499 0.944946 10.5897 0.17334 8.89835C-0.598297 7.20701 1.46765 5.50305 4.82794 5.11177L4.80307 5.07391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_2688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 22,
    fill: "white",
    transform: "matrix(-1 0 0 1 451 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection7WhiteStrike);
export default __webpack_public_path__ + "static/media/section7WhiteStrike.b6d658294709cc0906b647a2b40e454a.svg";
export { ForwardRef as ReactComponent };